import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { YAxisComponent as NgxChartsYAxisComponent } from '@swimlane/ngx-charts';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'g[qmg-charts-y-axis]',
    templateUrl: './y-axis.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class YAxisComponent extends NgxChartsYAxisComponent {
   @Input() referenceLinesOutlet?: CdkPortalOutlet;
}
